import clsx from 'clsx';
import { AmenityItem, AmenityLabel, IconWrapper } from './Amenity.styles';
import { AmenityProps } from './Amenity.types';
import { parseIconClass } from './utils';

export function Amenity({ className, iconClass, label }: AmenityProps) {
  return (
    <AmenityItem className={className}>
      <IconWrapper>
        <span className={clsx('icon', parseIconClass(iconClass))} />
      </IconWrapper>
      {label ? <AmenityLabel className="t-font-alt-xs fw-bold">{label}</AmenityLabel> : null}
    </AmenityItem>
  );
}
